import midAutumn from '@/views/act/midAutumnAccum2026/assets/locales/id.js'
import halloween from '@/views/act/halloween/assets/locale/id.js'
export default {
  midAutumn,
  halloween,
  "props": {
    "90501249": "Gelar – Bulan Purnama Festival",
    "10101048": "Groza-Mimpi Malaikat 7 Hari",
    "10101059": "M762-Jade Faced Fox 7 Har",
    "70100004": "Cash",
    "70100101": "Diamond Emas",
    "80102101": "Tiket Spin Diamond Emas",
    "80202003": "Kartu EXP Senjata LV3",
    "1010504001": "P90-Withered Bloom 5 Hari",
    "80103001": "Perlindungan Rank",
    "80103002": "Kartu Ranking Poin Ganda",
    "70100011": "Gold",
    "70100014": "Kunci Mystic",
    "81010999": "Koin Pertumbuhan Universal",
    "70100013": "Mystic Voucher",
    "50120500": "Pertengahan Musim Panas: Tunas Lukis",
    "90301912": "[Frame Avatar] Legenda Keberuntungan",
    "90501246": "[Judul] Legenda Keberuntungan",
    "90301913": "[Frame Avatar] Master Keberuntungan",
    "90501247": "[Judul] Master Keberuntungan",
    "90301914": "[Frame Avatar] Pencari Keberuntungan",
    "90501248": "[Judul] Pencari Keberuntungan",
    "70100012": "Mystic Gem",
    "32701009": "Paket Full Gear Advanced"
  },
  "payment": {
    "popupEvent": {
      "joinImmediate": "Gabung Sekarang",
      "noMoreTip": "Jangan ingatkan aku lagi hari ini."
    },
    "videoIntro": "Diamond Colourful adalah mata uang dalam game dan dapat digunakan pada pembelian paket, tanpa ada biaya tambahan!\n\nNilai Diamond Colourful sebagai pembayaran tunai dalam game, dan akan ada bonus hadiah setiap pembelian Diamond Colourful!\n\nContoh: Membeli paket senilai Rp. 169,000 dalam game dengan Diamond Rp. 169,000, dapatkan 10% bonus tambahan setiap isi ulang Diamond Colourful Rp. 169,000.\n\nTips: Pengisian ulang Diamond Colourful pertama kali akan mendapatkan bonus maksimal 100%!",
    "post": {
      "title": "Konten Lainnya",
      "announcement": "Pengumuman",
      "faq": "FAQ"
    },
    "howToCheckUserId": "Cara melihat ID karakter",
    "title": "Top-up Resmi, Hadiah Bonus!",
    "noData": "Tidak ada data",
    "tip": "Perhatian",
    "notStart": "Event belum dimulai",
    "ended": "Berakhir",
    "maintainTip": "Saluran pembayaran ini sedang dalam pemeliharaan. Silakan coba lagi nanti.",
    "validateUser": {
      "title": "Verifikasi Karakter",
      "enterUserId": "Harap masukkan ID Karakter Anda",
      "desc": "ID Karakter",
      "submit": "Konfirmasi",
      "noUserText": "Harap cari dan konfirmasi informasi Anda terlebih dahulu",
      "queryLimitExceeded": "Terlalu banyak permintaan. Coba lagi nanti.",
      "userNotFound": "ID Peran tidak ada. Harap periksa dan masukkan kembali."
    },
    "userDialog": {
      "id": "ID Karakter",
      "name": "Nama Karakter",
      "confirmText": "Harap konfirmasi informasi karakter",
      "confirmInput": "Konfirmasi",
      "cancelInput": "Masukkan Kembali"
    },
    "payStatusDialog": {
      "cancelText": "Batalkan",
      "paySuccess": "Top-up Selesai!",
      "payFailed": "Top-up Gagal",
      "paying": "Mencari..."
    },
    "mallGuideDialog": {
      "title": "Top-Up Berhasil",
      "desc": "Top-Up Diamond Colorful kamu berhasil. Kunjungi Toko Keanggotaan sekarang untuk mengklaim hadiah kamu!",
      "claimLater": "Klaim Nanti",
      "goNow": "Kunjungi Sekarang"
    },
    "paymentMethod": {
      "title": "Pilih Metode Pembayaran",
      "recommend": "Direkomendasikan",
      "moreMethod": "Metode Pembayaran Lain",
      "confirm": "Konfirmasi",
      "diankaTip1": "",
      "diankaTip2": ""
    },
    "product": {
      "title": "Pilih Paket Top-up",
      "gift-single": "Bonus",
      "gift": "Bonus",
      "giftRegular": "Bonus Reguler",
      "giftActivity": "Pengguna Baru Mendapatkan Tambahan",
      "giftActivityBadge": "Pengguna Baru Mendapatkan Tambahan {num}",
      "giftRegularBadge": "+{num} Rainbow Diamonds",
      "giftPointsBadge": "+{num} Poin",
      "coinTotal": "Total {total} ({coin}+{gift})",
      "coinTotalOnly": "Total {total}",
      "remaining": "Tersisa {num} Kali",
      "points": "Poin",
      "summary": "Informasi Ringkasan",
      "selected": "Paket yang Dipilih",
      "diamond": "Berlian Pelangi",
      "total": "Harga Total",
      "confirm": "Konfirmasi",
      "limit": "Batas Pembelian"
    }
  },
  "header": {
    "memberStore": "Member Store"
  },
  "tabbar": {
    "recharge": "Top Up",
    "pointsMall": "Points Mall"
  },
  "footer": {
    "link": {
      "privacy": "Ketentuan Pengguna",
      "security": "Kebijakan Privasi"
    },
    "jumpLink": {
      "fb": "https://www.facebook.com/profile.php?id=61576844188118",
      "fbGroup": "https://www.facebook.com/groups/mwr.id",
      "dc": "https://discord.gg/Eqje65WBpf",
      "yt": "https://www.youtube.com/{'@'}miniworldroyale.indonesia",
      "tt": "https://www.tiktok.com/{'@'}miniworldroyale.id",
      "privacy": "https://www.miniworldroyale.com/terms/19",
      "security": "https://www.miniworldroyale.com/terms/20"
    },
    "text": "Jika Anda mengalami masalah selama pembayaran, harap kirim email ke ministarcustomerservice{'@'}gmail.com untuk bantuan."
  },
  "customerServiceText": "Harap hubungi kami melalui email di ministarcustomerservice{'@'}gmail.com",
  "cancelText": "Kembali ke Top-Up",
  "api": {
    "networkError": "Kesalahan Jaringan",
    "serverError": "Kesalahan Server, Kode Kesalahan:"
  },
  "poolParty": {
    "box1": "Harta Karun Langka",
    "box2": "Harta Karun Mewah",
    "loginDialog": {
      "title": "Verifikasi karakter untuk dapatkan hadiah awal"
    },
    "prop": {
      "ACTIVITY_SWIM_RING": "Pelampung",
      "ACTIVITY_WATER_GUN": "Pistol Air",
      "ACTIVITY_SUN_UMBRELLA": "Payung Pantai",
      "ACTIVITY_SWIM_GOGGLES": "Kacamata Renang",
      "80202003": "Kartu EXP Senjata LV3",
      "70100101": "Diamond Emas ",
      "80102101": "Tiket Spin Diamond Emas",
      "80102004": "Voucher Cash",
      "80103001": "Perlindungan Rank",
      "80103002": "Kartu Ranking Poin Ganda ",
      "70100011": "Gold",
      "70100014": "Kunci Mystic",
      "70100013": "Mystic Voucher",
      "81010999": "Koin Pertumbuhan Universal",
      "90301907": "[Hadiah Ekslusif] Frame Avatar – Pool Party"
    },
    "record": {
      "title": "Riwayat Pemenang",
      "detailTitle": "Rincian Hadiah",
      "dateTitle": "Waktu Klaim",
      "noData": "Tidak ada data"
    },
    "btnCanReceive": "Tersedia",
    "btnReceived": "Diterima",
    "btnNotReach": "Belum tercapai",
    "goRecharge": "Pergi ke Top-up",
    "welcomeReward": {
      "title": "Hadiah Awal",
      "desc": "Klaim setelah melengkapi verifikasi karakter"
    },
    "exchange": {
      "desc1": "Kumpulkan semua item Pool Party dan dapatkan Frame avatar acara eksklusif—Pool Party—secara gratis.",
      "desc2": "Selama periode, setelah mencapai akumulasi top-up 1,000 - 2,000 - 3,000 Diamond Colorful, silahkan klaim hadiah tambahan Pool Party yang belum kamu punya.",
      "mainPropName": "[Hadiah Ekslusif] Frame Avatar – Pool Party"
    },
    "dailyReward": {
      "day": "Day {day}",
      "desc": "Buka harta karun setelah melakukan pembelian Diamond Colourful pertama setiap hari."
    },
    "accumReward": {
      "itemTitle": "Hadiah Pool Party",
      "itemCountText": "Akumulasi Top-up Diamond Colorful mencapai {need}({current}/{need})",
      "randomProp": "Item Pool Party Random",
      "randomPropNotOwned": "Item Pool Party Random (Belum Dimiliki)"
    },
    "rule": {
      "item1": "Selama periode event, setelah top-up Diamond Colorful Pertama kamu, Kamu bisa klaim 1 Harta Karun Langka yang berisi hadiah ingame dan 1 item Pool Party Ekslusif.",
      "item2": "Ada total 4 item Pool Party yang berbeda: Pelampung Renang, Pistol Air, Payung Pantai, dan Kacamata Renang. Item-item ini hanya dapat digunakan di halaman acara ini. Kumpulkan keempat item Pool Party yang berbeda untuk mendapatkan hadiah eksklusif : [Hadiah Ekslusif] Frame Avatar – Pool Party.",
      "item3": "Harta Karun ke-3 dan ke-7 adalah Harta Karun Mewah yang berisi hadiah item dalam game tambahan dan dijamin akan lebih seru karena item yang belum kamu punya.",
      "item4": "Selama periode event, jika top up Diamond Colorful mencapai 1.000 / 2.000 / 3.000, kamu berkesempatan buka Paket Pool Party extra. Setiap Paket Pool Party dijamin berisi item berbeda.",
      "item5": "Penyelenggara berhak atas interpretasi akhir dari event ini.",
      "item6": ""
    }
  },
  "accumRecharge": {
    "countDownTitle": "Hitung Mundur Acara Dimula",
    "countFuhao": "*",
    "clickHere": "Klik di sini",
    "introduce": "Pergi ke Halaman Top-up Online [clickHere] Top-up 500/1000/2500/5000/10000 Diamond untuk dapatkan hadiah yang sesuai\nPeriode kegiatan: 2025/9/19 00:00:00 - 2025/10/06 23:59:59 (UTC+8)\nWaktu Klaim Hadiah akan berakhir pada 2025.10.12 23:59:59 (UTC+8)",
    "goRecharge": "Pergi ke Top-up",
    "rewards": {
      "goRecharge": "Pergi ke Top-up",
      "record": "Riwayat Pemenang",
      "rewardsAll": "Klaim Sekali Klik",
      "rewardTimes": "Jumlah Klaim:",
      "btnStatus": {
        "canReceive": "Dapat Diterima",
        "received": "Sudah Diterima",
        "goRecharge": "Pergi ke Top-up"
      },
      "recordTable": {
        "name": "Tingkat Top-up",
        "details": "Rincian Hadiah",
        "time": "Waktu Klaim"
      }
    },
    "rule": {
      "title": "Aturan Rincian Kegiatan:",
      "content": "Cara melakukan Top-up: Klik tombol [goRecharge] di atas untuk ke halaman top-up, silahkan pilih nominal yang sesuai untuk berpartisipasi!\nCara Klaim Hadiah: Setelah top-up, klik tombol klaim hadiah di atas dan hadiah otomatis masuk ke dalam game. Atau lakukan klaim melalui pesan di dalam game \nJumlah Klaim Hadiah: Setiap nominal top-up memiliki jumlah hadiah, top-up melebihi nominal tertera tidak menambah jumlah hadiah"
    },
    "rewardsAllDialog": {
      "content": "Klaim Berhasil dengan Satu Klik! \nAnda dapat memeriksa rinciannya di 【Riwayat Pemenang】"
    },
    "rewardsTimes": {
      "times": "kali"
    }
  },
  "accum": {
    "actStartCountDown": "Countdown Mulai Event",
    "actEndCountDown": "Countdown Event Selesai",
    "rewardEndCountDown": "Countdown Klaim Hadiah",
    "actEnded": "Event Selesai",
    "clickHere": "Klik Disini",
    "goRecharge": "Pergi ke Top-up",
    "record": "Riwayat Pemenang",
    "rewardsAll": "Klaim Sekali Klik",
    "rewards": {
      "eventDesc": "Gunakan situs Top-Up resmi [{clickHere}], dan dari akumulasi [Diamond Colorful] mencapai 100/300/500/1000/2000/3000/5000/10000, kamu dapat Klaim Hadiah Gratis!( Hanya nominal dasar [Diamond Colourful] yang dihitung. Bonus [Diamond Colourful] tidak termasuk.",
      "eventDescDuojin": "Hadiah untuk event ini ditambahkan! Kami menambahkan extra hadiah untuk Mode Terbaru {duojin} - Main dan dapatkan hadiahnya! ",
      "duojin": "[Mystic Raid]",
      "eventTime": "Periode Event: 12 Juni 2026 (00:00) - 21 Juni 2026 (23:59)  (GMT+7)",
      "rewardEndTime": "Waktu Klaim Hadiah akan berakhir pada 28 Juni 2026 (23:59) (GMT+7)",
      "diffDiamond": "Beli Diamond Colorful [diamondNum] lagi, dan klaim hadiah.",
      "btnCanReceive": "Tersedia",
      "btnReceived": "Diterima",
      "btnNotReach": "Belum tercapai",
      "canReceiveAll": "Anda dapat mengklaim semua hadiah"
    },
    "rewardsAllDialog": {
      "title": "Selamat, Kamu Mendapat Hadiah",
      "content": "Klaim Berhasil dengan Satu Klik!\nKamu dapat memeriksa rinciannya di [record]"
    },
    "recordDialog": {
      "title": "Riwayat Pemenang",
      "reachNode": "Detail Riwayat",
      "details": "Rincian Hadiah",
      "time": "Waktu Klaim",
      "noData": "Tidak ada data"
    },
    "rule": {
      "content": "1. Cara Top-Up:\nKlik tombol {goRecharge} diatas untuk akses situs top-up resmi dan lanjutkan membeli Diamond Colourful!\n\n2. Cara Klaim Hadiah:\nSaat akumulasi nominal top-up mencapai tingkat hadiah, ketuk Klaim. Hadiah akan dikirimkan melalui Mail dalam game. Jangan lupa login untuk dapatkan semua!\n\n3. Limit Hadiah:\nSetiap akumulasi hadiah top-up hanya dapat diklaim 1x, dan tidak bisa berulang.\n\n4. Disclaimer:\nSeluruh konten acara akan sesuai dengan tampilan di halaman event. Hasil akhir akan ditentukan oleh Tim Resmi."
    }
  },
  "cny": {
    "goRecharge": "Pergi ke Top-up",
    "record": "Riwayat Pemenang",
    "remainingTimes": "Sisa kesempatan undian",
    "skipAnimation": "Skip animasi undian",
    "lotteryOnce": "1x undian",
    "lotteryOneKey": "1x klik undian",
    "lottery": {
      "desc": "Pada situs topup resmi, setiap pembelian 500 Diamond akan mendapatkan 1x kesempatan Lucky Wheel.\n(Note: hanya dihitung dari nominal pembelian Diamond, bonus Diamond tidak dihitung)",
      "times": "Periode Akumulasi Top-up: 24 Desember 2025 [00.00] - 12 Januari 2026 [23.59] - GMT+7\nPeriode Klaim Hadiah : 24 Desember 2025 [00.00] - 18 Januari 2026 [23.59] - GMT+7"
    },
    "lotteryRewardDialog": {
      "title": "Selamat, Kamu Mendapat Hadiah"
    },
    "rewards": {
      "desc": "Akumulasi 2, 5, 10, 20, 30, dan 50 undian pada halaman event untuk dapatkan tambahan pengembangan.",
      "times": "Periode Akumulasi Top-up: 22 Desember 2025 [00.00] - 12 Januari 2026 [00.59] - GMT+7\nPeriode Klaim Hadiah: 22 Desember 2025 [00.00] - 18 Januari 2026 [23.59] - GMT+7",
      "lotteryNTimes": "Sudah {times} Undian",
      "reachNode": "Tingkat Hadiah",
      "rewardsAllDialog": {
        "content": "Klaim Berhasil dengan Satu Klik!\nKamu dapat memeriksa rinciannya di 【Riwayat Pemenang】"
      }
    },
    "rule": {
      "content": "1. Top-up Diamond di platform resmi, kamu berkesempatan mendapatkan 1x kesempatan Lucky Wheel. (Note: hanya dihitung dari nominal pembelian Diamond, bonus Diamond tidak dihitung)\n2. Akumulasi 2, 5, 10, 20, 30, dan 50 undian pada halaman event untuk dapatkan tambahan pengembangan.\n3.Periode Akumulasi Top-up: 24 Desember 2025 [00.00] - 12 Januari 2026 [23.59] - GMT+7\tPeriode Klaim Hadiah : 24 Desember 2025 [00.00] - 18 Januari 2026 [23.59] - GMT+7\n4. Segala bentuk keputusan Tim adalah mutlak."
    }
  },
  "mwr": {
    "actTimeDialogText": "Event ini akan resmi dimulai pada 13 Februari pukul 00:00（GMT+7）. Stay tuned!",
    "actTimeDialogText2": "",
    "save": "Simpan",
    "share": "Bagikan",
    "mission": {
      "receiveRewardSuccess": "Hadiah berhasil diklaim.",
      "header": "Misi",
      "progress": "Progress",
      "btns": {
        "canReceive": "Mendapatkan",
        "received": "Selesai",
        "notReach": "Belum Selesai",
        "shareImmediate": "Bagikan Sekarang"
      },
      "list": {
        "1": {
          "key": "dailyLogin",
          "title": "Hadiah Gratis Login Game",
          "desc": "Harian"
        },
        "2": {
          "key": "loginDaysGt3",
          "title": "Akumulasi Login Game: 3 hari",
          "desc": "Misi 1 kali"
        },
        "3": {
          "key": "loginDaysGt7",
          "title": "Akumulasi Login game: 7 hari",
          "desc": "Misi 1 kali"
        },
        "4": {
          "key": "shareMwr",
          "title": "Bagikan Title / Rekap ke media sosial",
          "desc": "Misi 1 kali"
        },
        "5": {
          "key": "playedFiveNewMode",
          "title": "Main 3 Jenis Mode ",
          "desc": "Harian"
        },
        "6": {
          "key": "playedFiveNewMode",
          "title": "Main mode baru - 5 kali",
          "desc": "Misi 1 kali"
        }
      }
    },
    "turn": "Jumlah Serangan",
    "turnNum": "Jumlah Serangan+{num}",
    "logout": "Keluar Game",
    "home": {
      "statsPage": {
        "text": "Battle\nBook",
        "btnText": "Lihat"
      },
      "dragonPage": {
        "text": "Kalahkan\nNaga",
        "btnText": "Lanjutkan"
      }
    },
    "dragon": {
      "noTurn": "Percobaan serangan tidak tersedia.",
      "serverProgress": "Program Seluruh Server ",
      "treasureBox": {
        "notReach": "Belum Selesai ",
        "received": "Selesai"
      },
      "rule": "Seluruh Player Server harus bersatu untuk mengalahkan naga jahat.\nSaat akumulasi damage naga mencapai pada batas tertentu, kamu bisa klaim hadiah dari chest tersedia.\n1. Setiap serangan ke naga akan menghabiskan 1 Percobaan Serangan.\n2. Percobaan Serangan bisa didapatkan dengan menyelesaikan misi.\n3. Ketika total damage ke naga mencapai 4.052, 10.130, dan 20.260, Progress Chest yang sesuai akan terbuka. Player kemudian bisa klaim hadiah di dalam chest.\n4.Saat membuka chest, ada peluang untuk mendapatkan Ultra Rare Chest. Hadiah dari Ultra Rare Chest akan langsung menggantikan hadiah chest biasa.\n5. Drop rate Ultra Rare Chest adalah 0,001%, dan 19.999 Diamond Emas akan menjadi hadiahnya.\n6. Saat naga jahat dikalahkan, semua player akan mendapatkan hadiah melalui email.\n\nFAQ\n1. Kapan event ini berlangsung?\nPeriode event: 8 Februari, 00:00 – 1 Maret, 23:59 (GMT+7)\nPeriode klaim hadiah: 8 Februari, 00:00 – 8 Maret, 23:59 (GMT+7)\n\n2. Bagaimana cara reward dikirimkan?\nSemua reward selama event akan dikirim lewat in-game mail, jadi jangan lupa cek mailbox kamu di dalam game ya!\n\n3. Bagaimana menyimpan screenshot halaman Book Battle?\nKlik tombol \"Simpan\" di pojok kanan bawah pada halaman Book Battle. Screenshot akan otomatis muncul—tekan dan tahan gambar untuk menyimpan ke galeri HP kamu.\n\n4. Apakah tetap bisa bergabung event jika naga sudah dikalahkan?\nPlayer tidak dapat mengikuti event kembali untuk mendapatkan peti tambahan jika naga sudah dikalahkan. Jadi, ikuti event tepat waktu ya!\n\n5. Apakah klaim hadiah bisa lebih dari satu kali?\nKlaim hadiah hanya 1x, Top-up berulang tidak memberikan hadiah yang sama.\n\n6. Kenapa misi harian sudah selesai tapi percobaan serangan tidak bertambah?\nSetelah kamu menyelesaikan misi, sistem butuh sekitar 30 detik untuk verifikasi hasil misi. Tunggu sebentar ya~\n\n7. Apa yang terjadi kalau tidak klaim hadiah tepat waktu?\nPastikan kamu klaim hadiah sebelum 1 Maret, 23:59 (GMT+7). Hadiah yang tidak diklaim setelah batas waktu akan dianggap hangus dan tidak bisa dikembalikan.\n\n8. Bagaimana cara menghubungi customer support?\nKirim email ke ministarcustomerservice{'@'}gmail.com dengan menyertakan Player ID dan Waktu Klaim Hadiah. Tim kami akan membantu secepat mungkin.",
      "boxRecord": {
        "title": "Riwayat Hadiah",
        "box": "Peti",
        "reward": "Hadiah",
        "time": "Tanggal diterima",
        "box1Name": "Peti I",
        "box2Name": "Peti II",
        "box3Name": "Peti III"
      },
      "superBox": {
        "text1": "Naga Jahat telah dikalahkan!",
        "text2": "Hadiah bagi seluruh server sudah tersedia di ingame mail kamu. Masuk dan klaim hadiahnya sekarang~",
        "text3": "Selamat Tahun Baru, Sharpshooter!"
      }
    },
    "stats": {
      "infos": {
        "page-1-left-title": "Battle Book",
        "page-1-left-desc": "Sharpshooter",
        "page-1-right-title": "Perjalanan Epik Kamu Tahun 2025",
        "page-2-left-title": "MOMEN BATTLE",
        "page-2-right-title": "MOMEN KOLEKSI",
        "totalGameTime": "Total waktu bermain",
        "totalKillCount": "Total kill",
        "alwaysPlayMode": "Mode Favorit ",
        "maxRankScore": "Pencapaian Ranking Tertinggi",
        "maxWeaponId": "Senjata Favorit",
        "maxLongWinningCount": "Kemenangan Terpanjang",
        "maxLongLoginDays": "Jumlah Login Terlama",
        "topFriendId": "Team Terdekat",
        "totalWeaponCount": "Total senjata yang dimiliki",
        "totalAvtCount": "Total skin dan perlengkapan DIY yang dimiliki",
        "modeType-1": "Gunfight Dual Tembak-Menembak",
        "modeType-2": "Mini Ops",
        "modeType-3": "Mutasi Savage",
        "hour": "Jam",
        "day": "Hari"
      },
      "chenghao": {
        "isForty": "Lawan Terbaik ",
        "isTwenty": "Eliminator Elit",
        "isGame100": "Global Apex",
        "modeID-1": "Gunfight - Arsitek Taktik",
        "modeID-2": "Mini Ops - Survival Hero",
        "modeID-3": "Savage - Penghancur Savage",
        "weaponType-1": "SCAR - Komandan Medan Tempur",
        "weaponType-2": "DMR - Tim Pelaksana",
        "weaponType-3": "SR - Silent Eksekutor",
        "weaponType-4": "Light MG - Suppressive Warlord",
        "weaponType-5": "SMG - Phantom Reaper",
        "weaponType-6": "Shotgun - Penghancur Musuh",
        "weaponType-7": "Heavy MG - Benteng Baja",
        "weaponType-8": "Melee - Tangan Dewa",
        "is10WValue": "Pencetus Gaya ",
        "is15WValue": "Penguasa Trend",
        "is20WValue": "Ikon Mistis"
      },
      "chenghaoDesc": {
        "isForty": "Top 40% dengan kill rate tertinggi",
        "isTwenty": "Top 20% dengan kill rate tertinggi",
        "isGame100": "Top 100 disemua mode",
        "modeID-1": "Mode paling sering dipilih",
        "modeID-2": "Mode paling sering dipilih",
        "modeID-3": "Mode paling sering dipilih",
        "weaponType-1": "Senjata paling sering dipakai",
        "weaponType-2": "Senjata paling sering dipakai",
        "weaponType-3": "Senjata paling sering dipakai",
        "weaponType-4": "Senjata paling sering dipakai",
        "weaponType-5": "Senjata paling sering dipakai",
        "weaponType-6": "Senjata paling sering dipakai",
        "weaponType-7": "Senjata paling sering dipakai",
        "weaponType-8": "Senjata paling sering dipakai",
        "is10WValue": "Skor fashion di atas 100.000",
        "is15WValue": "Skor fashion di atas 150.000",
        "is20WValue": "Skor fashion di atas 200.000"
      }
    }
  },
  "sf": {
    "endCountdown": "Hitung mundur untuk selesai",
    "startCountdown": "Hitung mundur untuk mulai",
    "ended": "Event ini sudah berakhir. Jangan lupa klaim hadiahmu tepat waktu",
    "notStart": "Event belum dimulai",
    "day": "Hari",
    "lottery": {
      "desc": "Selama Periode Event :\n1. Setiap Top-up 100 Diamond Colorful di Website Resmi, kamu akan mendapatkan 1 [Kembang Api] GRATIS.\n2. Setiap menyalakan [Kembang Api], kamu akan mendapatkan hadiah acak. Menyalakan [Kembang Api] secara berkala akan membuka tingkat hadiah lainnya sesuai akumulasi.\n3. Catatan : Hanya menghitung transaksi Diamond Colorful dasar yang tersedia di website. Bonus Diamond tidak termasuk. Mohon untuk menghitung akumulasi berdasarkan jumlah dasar.",
      "times": "Periode Akumulasi : 9 Februari 00:00 – 1 Maret  23:59 (GMT+7)\nPeriode Klaim Hadiah : 9 Februari 00:00 – 9 Maret 23:59 (GMT+7)",
      "remainingTimes": "Kesempatan tersedia",
      "skipAnimation": "Lewati Animasi Kembang Api"
    },
    "lotteryOnce": "Pasang 1 Kembang Api ",
    "lotteryOneKey": "Pasang semua Kembang Api",
    "rewards": {
      "canReceiveAll": "Anda dapat mengklaim semua hadiah",
      "diffDiamond": "Butuh [diamondNum] [Kembang Api] untuk klaim hadiah selanjutnya",
      "lotteryNTimes": "{times}kali"
    },
    "rule": {
      "content": "Selama Periode Event :\n1. Setiap Top-up 100 Diamond Colorful di Website Resmi, kamu akan mendapatkan 1 [Kembang Api] GRATIS.\n2. Setiap menyalakan [Kembang Api], kamu akan mendapatkan hadiah acak. Menyalakan [Kembang Api] secara berkala akan membuka tingkat hadiah lainnya sesuai akumulasi.\n3. Catatan : Hanya menghitung transaksi Diamond Colorful dasar yang tersedia di website. Bonus Diamond tidak termasuk. Mohon untuk menghitung akumulasi berdasarkan jumlah dasar."
    }
  },
  "wc2026": {
    "login": {
      "logintxt": "Login",
      "inputCode": "Silakan masukkan kode verifikasi",
      "sendCode": "Kirim kode verifikasi email in-game",
      "submit": "Konfirmasi",
      "cancel": "Batal",
      "codeSent": "Mohon periksa in-game mail untuk kode verifikasi.",
      "loginSuccess": "Login Berhasil",
      "codeError": "Login Gagal",
      "emailPlaceholder": "Silakan masukkan akun",
      "codePlaceholder": "Silakan masukkan kode verifikasi"
    },
    "logout": "[Keluar]",
    "intro": {
      "title": "Penjelasan Event",
      "contentText": "World Cup Cheer — Pilih tim favoritmu dan ada banyak hadiah menarik!\r\nSelesaikan misi harian untuk dapatkan “Cheer Chance”, lalu dukung tim favoritmu di halaman jadwal pertandingan.\r\nWorld Cup kali ini menghadirkan 48 tim dengan jadwal selama 39 hari — makin banyak pertandingan yang kamu dukung, makin besar hadiah milestone dan papan peringkat yang bisa kamu dapatkan!\r\nLogin setiap hari dan dukung terus tim favoritmu sampai final!"
    },
    "tabs": {
      "rewardHistory": "Riwayat Hadiah",
      "cheerCountLabel": "Cheer Chance Saya:",
      "goEarn": "Dapatkan Sekarang",
      "cheerPowCash": "Cheer Power Clash",
      "toCheer": "Dukung Tim"
    },
    "rank": {
      "title": "Papan Peringkat Cheer Master",
      "rank": "Peringkat",
      "nickname": "Username Akun",
      "winCount": "Cheer Berhasil",
      "awardDes": "Petunjuk hadiah: 50 pemain dengan prediksi benar bisa klaim hadiah!",
      "des2": "Peringkat 4–10: 700 Diamond Emas , Peringkat 11–25: 400 Diamond Emas , Peringkat 26–50: 200 Diamond Emas",
      "des1": "Juara 1: 2,000 Diamond Emas , Juara 2: 1,500 Diamond Emas ,Juara 3: 1,000 Diamond Emas"
    },
    "accountId": "ID Akun",
    "noData": "Data tidak tersedia",
    "reaawardName": "Nama Hadiah",
    "cheerTime": "Jumlah Dukungan Berhasil",
    "times": "Kali",
    "bet": {
      "matchResult": {
        "pending": "Pertandingan Belum Dimulai",
        "cheered": "Sudah Mendukung",
        "draw": "Pertandingan Dibatalkan",
        "win": "_team Menang",
        "daping": "Seri",
        "running": "Pertandingan Berlangsung"
      },
      "selectDate": "Jadwal Pertandingan",
      "noMatches": "Tidak ada pertandingan",
      "cheerSuccess": "Dukungan Berhasil",
      "confirm": {
        "content": "Konfirmasi Dukungan"
      }
    },
    "backTop": "Kembali ke Atas",
    "milestone,mainTitle": "Dukung Tim untuk Klaim Hadiah",
    "milestone": {
      "totalCheer": "Hadiah Cheer Milestone",
      "winCheer": "Hadiah Milestone Berhasil",
      "subTitleTotal": "Semakin banyak total pertandingan yang kamu dukung, semakin besar Hadiah yang bisa didapat.",
      "subTitleWin": "Semakin banyak prediksi dukungan yang berhasil, semakin besar hadiah yang bisa kamu klaim.",
      "betTarget": "_n kali",
      "title1": "Cheer_N_Kali",
      "title2": "Berhasil_Cheer_N_Kali"
    },
    "betTarget": "5 kali",
    "received": "Diklaim",
    "canReceive": "Tersedia untuk diklaim",
    "notReach": "Belum Tercapai",
    "rule": {
      "title": "Detail Aturan Cheer",
      "content": "1. Cara Mendukung Tim\r\nPilih 1 tim untuk didukung di setiap pertandingan. Cheer Chance akan langsung terpotong setelah konfirmasi dan pilihan tidak bisa diubah.\r\nDukungan dibuka maksimal 2 hari sebelum match dimulai dan ditutup saat pertandingan dimulai.\r\nBabak knockout menggunakan sistem yang sama tanpa opsi hasil seri. \r\n\r\n2. Perhitungan Hasil & Hadiah\r\nJika tim yang kamu dukung menang, kamu akan mendapatkan hadiah item in-game.\r\nKhusus fase grup, jika match berakhir seri, semua pendukung kedua tim tetap mendapat hadiah.\r\nHasil mengikuti skor resmi akhir pertandingan.\r\nTotal dukungan akan membuka milestone hadiah dan dukungan berhasil dihitung ke leaderboard. \r\n\r\n3. Catatan\r\nJika match dibatalkan, ditunda, atau tidak valid, Cheer Chance akan dikembalikan penuh.\r\nPenyalahgunaan bug atau farming tidak wajar akan dikenakan penalti hingga ban akun.\r\nKeputusan akhir event sepenuhnya ditentukan oleh Tim Operasional."
    },
    "record": {
      "matchTime": "Pertandingan",
      "rewards": "Hadiah",
      "cheerTime": "Waktu Cheer",
      "cheerWinTab": "Hadiah Dukungan",
      "milestoneTab": "Hadiah Milestone",
      "milestone": "Milestone",
      "receiveTime": "Waktu Terima",
      "target": "Target: "
    },
    "share": {
      "text": "Bagikan",
      "title": "Berhasil melakukan Cheer di _n_ pertandingan dan dapat hadiah ⚽",
      "description": "Skill pemenang~ Pertahankan Posisi!"
    },
    "mail": {
      "title": "Selamat! Cheer kamu berhasil!",
      "content": "Dear Sharpshooter,\r\nSelamat! Dukunganmu di event [Cheer Rush] berhasil! Tim yang kamu dukung berhasil meraih kemenangan, dan reward untuk sesi cheer ini sudah dikirim ke akunmu. Silakan cek in-game mail kamu ya.\r\n\r\nSemoga pengalaman bermainmu menyenangkan.\r\n\r\nTim Operasional Mini World Royale"
    },
    "item": {
      "id_70100004": "Kartu Upgrade Senjata LV3",
      "id_70100101": "Diamond Emas",
      "id_80102101": "Tiket Spin Diamond Emas",
      "id_70100011": "Gold",
      "id_32204003": "Mid-Tier Safety Box（7 hari）",
      "id_70100014": "Kunci Mystic",
      "id_81010999": "Koin Pertumbuhan Universal",
      "id_90501207": "Title",
      "id_90301905": "Bingkai",
      "id_90105303": "Avatar",
      "id_20500901": "Crosshairs-Football",
      "id_20400904": "Pendant-Peluit",
      "id_90301906": "Bingkai",
      "id_90501208": "Title"
    },
    "task": {
      "wc_daily_login": "Login Harian",
      "wc_daily_play_mojin1": "Main Mode Mystic Raid 1 Kali",
      "wc_daily_play_mojin3": "Main Mode Mystic Raid 3 Kali",
      "wc_daily_play_any3": "Main 3 Mode Apa Saja",
      "wc_daily_online_60m": "Akumulasi 60 menit online",
      "wc_weekly_share": "Bagikan Title/Kirim ke Media Sosial",
      "daily": "Misi Harian",
      "weekly": "Misi Mingguan"
    },
    "receiveSuccess": "Klaim Berhasil",
    "error": {
      "code1104": "Waktu telah kedaluwarsa",
      "code1105": "Sudah mendukung pertandingan ini",
      "code1106": "Percobaan dukungan tidak mencukupi",
      "code1202": "Hadiah telah diklaim",
      "code1203": "Tugas tidak selesai",
      "code1302": "Telah diklaim",
      "code1303": "Syarat tidak terpenuhi",
      "code1401": "Membagikan terlalu sering",
      "code13404": "Batas Harian Tercapai",
      "code13405": "Kode verifikasi Kedaluwarsa atau Tidak Valid",
      "code13406": "Terlalu banyak percobaan gagal hari ini. Silakan coba lagi besok atau hubungi MOD.",
      "code501": "Pemeriksaan pengguna gagal. User tidak ditemukan.",
      "code11402": "Login Kedaluwarsa",
      "code429": "Permintaan terlalu sering. Silakan coba lagi nanti."
    },
    "mailveritify_success": "Verifikasi Email Berhasil"
  },
  "monopoly": {
    "rule": "Aturan Event",
    "ruleContent": "1. Event berlangsung mulai 15 Agustus pukul 00.00 hingga 31 Agustus pukul 23.59 (GMT+7). Setelah event berakhir, player tidak dapat lagi memperoleh dadu melalui *top-up* Diamond, tapi bisa menggunakan sisa dadu yang dimiliki. Setelah 6 September pukul 23.59 (GMT+7), sisa dadu tidak dapat digunakan lagi dan peringkat akan dihitung. Halaman acara akan ditutup sepenuhnya pada 13 September pukul 23.59 (GMT+7).\n2. Login setiap hari selama event untuk mengklaim 1 Dadu Normal gratis, hingga 3 Dadu Normal. \n3. Dapatkan 1 Dadu Normal untuk setiap Topup 100 Diamond Colorful. Untuk Topup 1,000 Diamond Colorful mendapatkan 1 Bonus Dadu Keberuntungan.\n4. Putar Dadu Normal untuk bergerak secara acak 1–6 bagian.\n5. Dadu Keberuntungan berkesempatan pilih angka 1-6 sebelum bergerak.\n6. Papan berisi 24 bagian. Setelah satu putaran selesai, Kamu bisa lanjutkan kembali dan putaran kamu telah dicatat.\n7. Berhenti di bagian berbeda memberikan hadiah yang berbeda. Beberapa bagian khusus memicu acara khusus. Silakan lihat efek dalam game.\n8. Capai titik putaran tertentu untuk klaim hadiah. Lebih banyak putaran membuka hadiah yang lebih bagus\n9. Hadiah peringkat akan didistribusikan berdasarkan Peringkat Putaran akhir setelah acara berakhir. Harap klaim hadiah kamu sebelum event berakhir. \n10. Hadiah papan ranking akan dikirim ke ingame mail. Tekan untuk Klaim Hadiah. Hadiah yang tidak diklaim tidak bisa digunakan setelah event selesai.",
    "rewardRecord": "Riwayat Hadiah",
    "rewardRecordDialog": {
      "reward": "Hadiah",
      "time": "Waktu Memperoleh",
      "status": "Status",
      "statusPending": "Belum di Klaim",
      "statusExtracted": "Sudah di Klaim",
      "statusSent": "Terkirim",
      "empty": "Tidak ada data"
    },
    "mainRule": "Login Harian untuk klaim 1 Dadu Gratis. Batas maksimal 3 Dadu Gratis untuk selama event.\nDapatkan 1 Dadu setiap Top-up 100 Diamond Colorful.\nDapatkan 1 Bonus Dadu setiap Top-up 1,000 Diamond Colorful.",
    "logout": "Log Out",
    "loginTitle": "Karakter Verifikasi",
    "accountId": "Karakter ID",
    "login": {
      "logintxt": "[Login]",
      "inputCode": "Masukan Kode Verifikasi",
      "sendCode": "Kirim Kode",
      "submit": "Konfirmasi",
      "cancel": "Batal",
      "codeSent": "Mohon periksa in-game mail untuk kode verifikasi.",
      "loginSuccess": "Login Berhasil",
      "codeError": "Login Gagal",
      "emailPlaceholder": "Silakan masukkan akun",
      "codePlaceholder": "Masukan Kode Verifikasi"
    },
    "normalDiceNum": "Normal Dadu Tersisa : {num}",
    "universalDiceNum": "Dadu Keberuntungan Tersisa : {num}",
    "throwOnce": "Putar 1 Dadu",
    "throwAll": "Putar Semua Dadu",
    "pleaseLogin": "Silahkan login",
    "noDiceTitle": "Tidak ada Dadu tersisa",
    "noDiceTip1": "Dapatkan 1 {dice} setiap topup {amount} Diamond Colorful.",
    "noDiceTip2": "Dapatkan 1 Bonus {dice} setiap topup {amount} Diamond Colorful.",
    "noDiceNormal": "Dadu",
    "noDiceUniversal": "Dadu Keberuntungan",
    "noDiceGoRecharge": "Pergi ke Top-up",
    "chooseStepsTitle": "Pilih Nomor Dadu keberuntungan",
    "chooseStepsOption": "Lanjutkan {steps} Bagian",
    "chooseStepsConfirm": "Konfirmasi",
    "throwResultUnit": "{steps}",
    "throwAllRewardTip": "Kamu telah menggunakan semua Dadu ({steps} bagian). Hadiah diterima",
    "rewardTitle": "Selamat! Kamu mendapatkan",
    "rewardEmpty": "Tidak ada hadiah kali ini",
    "mysteryEmptyTitle": "Karakter Ekslusif telah dimiliki. Ganti dengan Peti Langka.",
    "boxRewardTitleNormal": "Hadiah Peti Langka",
    "boxRewardTitleLucky": "Hadiah Peti Mewah",
    "boxRewardTitleMystery": "Hadiah Ekslusif Anniversary",
    "confirm": "Konfirmasi",
    "dailyDiceClaimSuccess": "Dadu Normal +1",
    "dailyDiceTipPrefix": "Login Harian untuk klaim 1 Dadu Gratis, hingga ",
    "dailyDiceTipSuffix": " Dadu.",
    "dailyDiceRemainPrefix": "Klam Tersisa :",
    "dailyDiceClaim": "Klaim",
    "extractRewards": "Klaim Hadiah",
    "extractRewardsDesc": "Tekan tombol untuk klaim semua hadiah di ingame mail.",
    "extractSuccessTitle": "Hadiah telah dikirim ke kotak surat in-game",
    "noPendingRewards": "Tidak ada hadiah untuk diklaim",
    "circleRewards": "Buka hadiah lainnya dengan memutar lebih banyak!",
    "circleAccumulated": "Total Putaran : {count}",
    "circleLaps": "{count} Putaran",
    "lapRewardAlready": "Hadiah telah diklaim",
    "lapRewardNotReached": "Syarat putaran belum terpenuhi",
    "ranking": "Ranking Putaran",
    "rankingTable": {
      "rank": "Ranking",
      "nickname": "Nama Karakter",
      "laps": "Putaran",
      "time": "Waktu tercapai (GMT+7)"
    },
    "rankingEmptyNickname": "Kosong",
    "rankingRewardTitleSingle": "Hadiah Ranking {rank}",
    "rankingRewardTitleRange": "Hadiah Ranking {min}-{max}",
    "moveSteps": "Lanjutkan {steps} Bagian",
    "moveStepsBack": "Mundur {steps} Bagian",
    "moveStepsCastle": "Petak Kastil Anniversary: ke {steps}",
    "notStart": "Event belum dimulai",
    "ended": "Event ini sudah berakhir. Jangan lupa klaim hadiahmu tepat waktu",
    "startCountdown": "Hitung mundur untuk mulai",
    "rechargeCountDown": "Bonus Top-up Dadu Berakhir Dalam",
    "diceCountDown": "Penggunaan Dadu Berakhir Dalam",
    "countDownNotStarted": "Belum dimulai",
    "countDownEnded": "Sudah berakhir",
    "day": "Hari",
    "error": {
      "code401": "Login Kedaluwarsa",
      "code429": "Permintaan terlalu sering. Silakan coba lagi nanti.",
      "code2001": "Event belum dimulai",
      "code2002": "Event telah berakhir",
      "code2003": "Periode klaim hadiah telah berakhir",
      "code2004": "Event telah berakhir",
      "code2801": "Dadu harian sudah diklaim",
      "code2802": "Batas klaim dadu harian tercapai",
      "code2803": "Dadu harian tidak tersedia sekarang",
      "code2901": "Tidak ada Dadu tersisa",
      "code2902": "Jenis dadu tidak valid",
      "code2903": "Langkah yang dipilih tidak valid",
      "code2904": "Dadu Lucky tidak bisa roll semua",
      "code3001": "Tidak ada hadiah untuk diklaim",
      "code3002": "Klaim gagal. Silakan coba lagi nanti.",
      "code3101": "Syarat putaran belum terpenuhi",
      "code3102": "Hadiah telah diklaim",
      "code3201": "Ranking belum diselesaikan",
      "code3202": "Hadiah ranking sudah dikirim"
    }
  },
  "ann2026": {
    "title": "Anniversary Ignite Plan",
    "flamePower": "Flame Power",
    "item": {
      "70100004": "Kartu Poin",
      "80102101": "Tiket Spin Diamond Emas",
      "70100011": "Gold",
      "70100014": "Kunci Mystic",
      "70100013": "Mystic Voucher",
      "10101404": "AN94 - Osmanthus",
      "50111700": "Sheng Yunzhi",
      "80103001": "Kartu Perlindungan Rank",
      "1010102006": "M4-Serangan menggemaskan",
      "32701006": "Paket Gear Advanced",
      "90301910": "[Bingkai Avatar] Perayaan Anniversary",
      "90301911": "[Bingkai Avatar]Badai Api",
      "90501244": "【Title】Api Abadi",
      "90501245": "【Title】Bangkit dari Abu",
      "81010999": "Koin Pertumbuhan Universal",
      "TBD_avatar_frame": "[Bingkai Avatar] Perayaan Anniversary",
      "TBD_title": "Perayaan Anniversary",
      "TBD_pendant": "Pendant-Peluit"
    },
    "home": {
      "serverPower": "Semua Server - Flame Power"
    },
    "hero": {
      "howToPlay": "Ringkasan Event",
      "logout": "[Keluar]",
      "login": "[Masuk]"
    },
    "contribute": {
      "btnMain": "Kontribusi Power",
      "desc1": "Satukan kekuatan, Nyalakan acara - Kue kita paling seru!",
      "desc2": "Flame Power Tersedia: _n",
      "tabSupply": "Persediaan Flame",
      "tabRally": "Sharpshooters, Berkumpul!",
      "tabHistory": "Riwayat Hadiah"
    },
    "dialog": {
      "close": "Tutup"
    },
    "flameSupply": {
      "title": "Persediaan Flame",
      "subtitle": "SELESAIKAN MISI UNTUK MENDAPATKAN POWER",
      "claimed": "Diklaim",
      "completed": "Tersedia untuk diklaim",
      "incomplete": "Belum selesai"
    },
    "eliteRally": {
      "subtitle": "UNDANG TEMAN KEMBALI UNTUK MENDAPAT HADIAH",
      "inviteOne": "Undang 1 teman",
      "inviteMany": "Undang {count} teman",
      "claimed": "Diklaim",
      "claim": "Klaim",
      "locked": "Terkunci",
      "itemName": "Nama Item"
    },
    "rewardHistory": {
      "title": "Riwayat Hadiah",
      "reward": "HADIAH",
      "receivedAt": "WAKTU DITERIMA"
    },
    "congratulation": {
      "receivedReward": "HADIAH DITERIMA"
    },
    "howToPlay": {
      "body": "🎉 Light Up!!! · Misi Perayaan Anniversary\nDark Star telah memadamkan lilin di kue anniversary kita! Saatnya bersatu dengan Sharpshooter di seluruh server, kumpulkan Flame Power untuk menyalakan kembali kue anniversary dan nyalakan angka \"1\" untuk merayakan anniversary pertama Mini World Royale!\n\n📅 Periode Event\nPartisipasi: 15 Agustus – 6 Sept (GMT+7)\nKlaim Hadiah: Hingga 13 Sept (GMT+7)\n※ Hadiah yang tidak diklaim akan hangus.\n\n🔥 Cara Bermain\n1. Kumpulkan Flame Power — Selesaikan misi harian di Persediaan Flame\n2. Nyalakan Kue — Berkontribusi di Flame Power untuk progres server.\n3. Buka Hadiah —\n  · Hadiah Server: Capai progres 25% / 50% / 75% / 100% untuk menyalakan setiap lapisan kue. Semua pemain yang berpartisipasi akan membuka hadiah bersama! Nyalakan angka \"1\" untuk mendapatkan hadiah utama, Bingkai Avatar, dan Gelar eksklusif.\n  · Hadiah Pribadi: Raih hadiah milestone berdasarkan total kontribusimu. Semakin besar kontribusimu, semakin besar hadiahnya!\n\n🤝 Sharpshooter, Bersatu!\nAjak kembali temanmu yang sudah lama tidak bermain! Semakin banyak yang kembali, semakin besar hadiahnya. Capai target untuk mendapatkan Frame Avatar dan Gelar eksklusif!\n\n🏆 Riwayat Hadiah\nSemua hadiah yang telah kamu klaim dapat dilihat di Riwayat Hadiah."
    },
    "powerContributed": {
      "text": "Power yang dikontribusikan: {count}"
    },
    "task": {
      "ann_daily_login": "Login Harian",
      "ann_daily_mojin_1": "Main Mode Mystic Raid 1 Kali",
      "ann_daily_mojin_3": "Main Mode Mystic Raid 3 Kali",
      "ann_daily_play_any_1": "Mainkan 1 Mode Apa Saja",
      "ann_weekly_share": "Bagikan ke Sosial Media",
      "ann_weekly_mojin_cake": "Dapatkan Red Item Mystic Raid: Kue Anniversary",
      "dailyLabel": "Harian",
      "weeklyLabel": "Mingguan"
    },
    "milestone": {
      "times": "_n kali",
      "claim": "Tersedia untuk diklaim",
      "claimed": "Diklaim",
      "notAchieved": "Belum Tercapai",
      "reward_1": "Avatar Frame",
      "reward_2": "10000 card point",
      "reward_3": "2 Golden Diamond Draw Ticket",
      "reward_4": "Title",
      "reward_5": "30 Mystic Voucher",
      "reward_6": "3 Golden Diamond Draw Ticket",
      "reward_7": "6 Million Gold",
      "reward_8": "3 Golden Diamond Draw Ticket",
      "reward_9": "Pendant",
      "reward_10": "1 Mystic Key",
      "reward_11": "AN94"
    },
    "footer": {
      "privacyPolicy": "Kebijakan Privasi",
      "userAgreement": "Perjanjian Pengguna",
      "customerService": "Harap hubungi kami melalui email di ministarcustomerservice{'@'}gmail.com"
    },
    "accountId": "Account ID",
    "logout": "Keluar",
    "needLogin": "Please login to participate",
    "phase": "Phase",
    "timeRange": "Play time",
    "availableFire": "Available fire",
    "totalFire": "Total fire",
    "ignite": "Ignite",
    "share": "Bagikan",
    "firstLoginReward": "Claim first login reward",
    "refresh": "Refresh",
    "receive": "Klaim",
    "received": "Diklaim",
    "notReady": "Belum selesai",
    "unlocked": "Unlocked",
    "locked": "Terkunci",
    "recallCount": "Recall count",
    "igniteOk": "Ignite success, consumed",
    "shareOk": "Berhasil Dibagikan",
    "receiveOk": "Klaim Berhasil",
    "section": {
      "activity": "Activity info",
      "fire": "My firepower",
      "global": "Global stages",
      "task": "Tasks",
      "milestone": "Milestones",
      "recall": "Recall",
      "record": "Reward records"
    },
    "login": {
      "logintxt": "Login",
      "inputCode": "Silakan masukkan kode verifikasi",
      "sendCode": "Kirim kode verifikasi email in-game",
      "submit": "Konfirmasi",
      "cancel": "Batal",
      "codeSent": "Mohon periksa in-game mail untuk kode verifikasi.",
      "loginSuccess": "Login Berhasil",
      "emailVerificationSuccess": "Verifikasi Email Berhasil",
      "birthday": "Happy Birthday!!!",
      "codeError": "Login Gagal",
      "emailPlaceholder": "Silakan masukkan akun",
      "codePlaceholder": "Masukkan kode verifikasi",
      "accountLabel": "ID Akun",
      "codeLabel": "Kode Verifikasi"
    },
    "error": {
      "code401": "Login Kedaluwarsa",
      "code2201": "Tugas tidak selesai",
      "code2202": "Hadiah telah diklaim",
      "code2301": "Flame Power tidak cukup!",
      "code2401": "Node ini belum dibuka",
      "code2402": "Hadiah telah diklaim",
      "code2501": "Syarat tidak terpenuhi",
      "code2502": "Hadiah telah diklaim",
      "code2601": "Jumlah Sharpshooter yang kembali belum mencukupi",
      "code2602": "Hadiah telah diklaim",
      "code2801": "Hadiah telah diklaim",
      "code2001": "Event belum dimulai",
      "code2002": "Event telah berakhir",
      "code429": "Batas Harian Tercapai"
    }
  }
}
